/**
 * @param state
 * @author       jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright Copyright (c) 2021, Zumper
 */

import { filterActions } from '@zumper/redux-ignore'

import * as constants from './constants'
import { renterQuestionsReducer } from './reducers/index'

export const renterQuestions = filterActions(renterQuestionsReducer, Object.values(constants))
